import Manager from '../Manager';

export default function(axios) {
  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.status === 403 && error.data && error.data.errors && error.data.errors.code == 1) {
      Manager.reinitUser().then(function(){
        location.reload(true);
      });
    } else {
      return Promise.reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/common/auth/interceptors/Forbidden.js